import { UnitDTO } from "./unit";

export enum UnitConformityStatus {
    OK = 'Conform',
    PARTIAL_OK = 'Ok met opmerkingen',
    NOT_OK = 'Niet conform',
    NOT_REQUIRED = 'Geen conformiteitsattest nodig',
    UNKNOWN = "Niet nagekeken"
  }
  

export type UnitConformityInfo = {
    id: number;
    unit: UnitDTO;
    unitConformity: UnitConformityStatus;
    unitConformityRemarks: string;
    unitConformityScore: string;
    unitMaxCapacityPersons: string;
    unitConformityAttestFileLogId: number;
    unitConformityAttestFileLog: any;
}